import React from 'react';
import { Contact } from '../components/Contact';
export function Contacto() {
  return <div className="pt-24 md:pt-28" data-id="element-342">
      <Contact data-id="element-343" />
    </div>;
}